import React, { useMemo } from 'react';
import { Popover } from '@headlessui/react';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import AccountDropdown from 'components/commercetools-ui/organisms/account/account-atoms/account-dropdown';
import { useFormat } from 'helpers/hooks/useFormat';
import { useAccount } from 'frontastic';
import { SmartLink } from 'components/commercetools-ui/atoms/smart-link';

const AccountButton = () => {
  const { account, loggedIn } = useAccount();
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });
  const userName = useMemo(() => {
    return `${account?.salutation ?? formatAccountMessage({ id: 'hello', defaultMessage: 'Hi, ' })} ${
      account?.firstName ?? formatAccountMessage({ id: 'user', defaultMessage: 'User' })
    }`;
  }, [account?.firstName, account?.salutation, formatAccountMessage]);

  const title = account
    ? formatAccountMessage({ id: 'account', defaultMessage: 'Account' })
    : formatAccountMessage({ id: 'sign.in', defaultMessage: 'Login' });
  const contentFulHeader = true;
  return !contentFulHeader ? (
    <div className="h-40">
      <SmartLink href={account ? '/account' : '/login'} showLoader={false} title={title}>
        <i className="icon icon-account-header hidden text-28 text-secondary-black md:flex lg:hidden"></i>
      </SmartLink>
      <Popover as="div" className="relative hidden h-fit lg:block">
        {() => (
          <>
            <Popover.Button title={title}>
              <div className="flex w-fit whitespace-nowrap">
                <div className="mr-8 mt-6 hidden py-4 lg:inline-block">
                  {loggedIn && (
                    <Typography className="hidden truncate text-secondary-black lg:block">{userName}</Typography>
                  )}
                </div>

                <div className="account-icon">
                  <i className="icon icon-account-header text-24 text-primary-black"></i>
                </div>
              </div>
            </Popover.Button>
            <Popover.Overlay className="fixed inset-0 z-[310] bg-secondary-black opacity-30" />
            <Popover.Panel
              className={`absolute ${
                account ? '-left-25' : '-left-100'
              } top-50 z-[310] animate-[appearDropdown_0.15s_ease-in-out] rounded-sm bg-white shadow-400`}
            >
              <div className="absolute -top-20 left-1/2 z-10 w-31 -translate-x-1/2 overflow-hidden">
                <div className="h-21 w-21 origin-bottom-left rotate-45 bg-white" />
              </div>
              <AccountDropdown loggedIn={loggedIn} />
            </Popover.Panel>
          </>
        )}
      </Popover>
    </div>
  ) : (
    <div className="hidden h-40 lg:flex">
      <SmartLink href={account ? '/account' : '/login'} showLoader={false} title={title}>
        <i className="icon icon-account-header hidden text-28 text-secondary-black md:flex lg:hidden"></i>
      </SmartLink>
      <Popover as="div" className="relative hidden h-fit lg:block">
        {() => (
          <>
            <Popover.Button title={title}>
              <div className="flex w-fit whitespace-nowrap">
                <div className="mr-8 mt-6 hidden py-4 lg:inline-block">
                  {loggedIn && (
                    <Typography className="hidden truncate text-secondary-black lg:block">{userName}</Typography>
                  )}
                </div>

                <div className="relative cursor-pointer pb-8 after:absolute after:bottom-0 after:left-1/2 after:block after:h-[2px] after:w-0 after:bg-[#7ce3be] after:opacity-0 after:[transition:width_0.55s,margin_0.55s,opacity_0.35s] hover:after:ml-[-50%] hover:after:w-full hover:after:opacity-100">
                  <i className="icon icon-account-header text-28 text-secondary-black"></i>
                </div>
              </div>
            </Popover.Button>
            <Popover.Overlay className="fixed inset-0 z-[310] bg-secondary-black opacity-30" />
            <Popover.Panel
              className={`absolute ${
                account ? '-left-25' : '-left-100'
              } top-50 z-[310] animate-[appearDropdown_0.15s_ease-in-out] rounded-sm bg-white shadow-400`}
            >
              <div className="absolute -top-20 left-1/2 z-10 w-31 -translate-x-1/2 overflow-hidden">
                <div className="h-21 w-21 origin-bottom-left rotate-45 bg-white" />
              </div>
              <AccountDropdown loggedIn={loggedIn} />
            </Popover.Panel>
          </>
        )}
      </Popover>
    </div>
  );
};

export default AccountButton;
